export const variablePrecision = (v: number) => v.toLocaleString('en-AU', { maximumFractionDigits: v >= 10 ? 0 : 2 })
